export default "__VITE_ASSET__DyiKu_JZ__"